/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './editJoinLink.defs'
export { main as default } from './editJoinLink.defs'
